import {store} from '../config/redux'

export const isClient = (client, clientId) => client?.id === clientId;

const getCurrentClient = () => {
  return store.getState().auth.client;
};

export const isArcosDorados = () => {
  const client = getCurrentClient();
  return isClient(client, "f025fad3-cc10-11ee-86a9-02519636e355");
};

export const isAlsea = () => {
  const client = getCurrentClient();
  return isClient(client, "8ed659d6-cbd7-11ee-86a9-02519636e355");
};
